import React from 'react'

import CatalogContainer from '../components/catalog/CatalogContainer'

const CatalogScreen = props => <CatalogContainer {...props} />

export default CatalogScreen
